<template>
  <Container>
    <div class="ui segments raised">
      <CardTitle
        title="Link Cliente Zendesk"
        icon-class="asterisk icon"
        title-class="ui green large ribbon label"
      >
      </CardTitle>
      <ContainerBody>
        <div class="inline fields">
        <Input
          v-model="ticket"
          label="Ticket"
          size="three"
          type="text"
        />
        <Button
          title="Gerar"
          :disabled="false"
          classIcon="icon check"
          @click="gerarLink()"
        >
        </Button>
        </div>
      </ContainerBody>
      <ContainerBody
      >
      <InputCopy
          v-model="linkzandesk"
          customClass="blue icon labeled"
          label="Link Gerado"
          size="sixteen"
          :iconLabeled="true"
          :disabledInput="true"
          :enableIcon="true"
          iconClass="icon copy"
        >
        Copiar
      </InputCopy>
      <div class="ui grid" style="margin-bottom: 5px;">
        <div class="six wide column">
        </div>
        <div class="seven wide column right aligned">
          <label>Pesquisar:</label>
        </div>
        <div class="three wide column">
          <input
            v-model="search"
            type="text"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="table-scroll">
          <v-data-table
            :headers="dataHeaders"
            :items="listaItems"
            :items-per-page="10"
            class="ui table very compact celled selectable dataTable" style="width: 100%; white-space: nowrap;"
            :search="search"
          >
          <template v-slot:item="{ item }">
              <tr>
                <td>{{item.registro}}</td>
                <td> {{item.codigo}} {{item.codigo > 0 ? '-' : ''}} {{item.razaosocial}}</td>
                <td class="center aligned">
                  <Button
                    title="Copiar"
                    :disabled="item.confirmado == 'S'"
                    classIcon="icon copy"
                    classButton="ui blue icon labeled small"
                    buttonColor="blue"
                    @click="buttonLink(item.link)"
                  >
                  </Button>
                </td>
                <td class="center aligned">{{ formatarData(item.dataexpiracao) }}</td>
                <td class="center aligned">{{item.horaexpiracao}}</td>
                <td class="center aligned">
                  <label :class="['ui label green small', { 'green': !item.vencido, 'red': item.vencido }]">{{item.textoVencido }}</label>
                </td>
                <td class="center aligned">
                   <Button
                    title="Novo"
                    classIcon="icon refresh"
                    buttonColor="green"
                    :disabled="item.confirmado == 'S'"
                    @click="buttonNovo(item.registro)"
                  >
                  </Button>
                </td>
                <td class="center aligned">
                  <label :class="item.situacao[0].class">{{item.situacao[0].text}} </label>
                  </td>
              </tr>
          </template>
          </v-data-table>
        </div>
      </ContainerBody>
    </div>
  </Container>
</template>

<script>

import Container from '@/components/Container.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import CardTitle from '@/components/CardTitle.vue';
import InputCopy from '@/components/InputCopy.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import lodash from 'lodash';
import moment from 'moment';

import api from '@/services/api';

import numeral from 'numeral';
import 'numeral/locales/pt-br';
import axios from 'axios';

numeral.locale('pt-br');
export default {
  name: 'GeraLinZenDesk',
  data() {
    return {
      search: '',
      loadingItens: false,
      dataItems: [],
      dataFooters: '',
      titleModal: '',
      equipamentos: '',
      dataHeaders: [
        { text: 'Ticket', align: 'start', value: 'registro' },
        { text: 'Cliente', align: 'end', value: 'razaosocial' },
        { text: 'Link', value: 'buttonlink' },
        { text: 'Data Expiração', align: 'start', value: 'dataexpiracao' },
        { text: 'Hora Expiração', align: 'start', value: 'horaexpiracao' },
        { text: 'Expirado', value: 'expirado' },
        { text: 'Gerar Novo', value: 'buttonnovo' },
        { text: 'Situação', value: 'situacao' },
      ],
      ticket: '',
      linkzandesk: '',
    };
  },
  components: {
    Container,
    ContainerBody,
    CardTitle,
    InputCopy,
    Input,
    Button,
  },
  computed: {
    listaItems() {
      return lodash.orderBy(this.dataItems, 'registro', 'asc');
    },
  },
  mounted() {
    this.listaTickets();
  },
  methods: {
    async gerarLink() {
      this.linkzandesk = '';
      this.$store.commit('global/loading');
      const dados = {
        ticket: this.ticket,
      };
      try {
        const response = await api.post('/api/rma/cliente/gerar', dados);
        if (response) {
          this.linkzandesk = response.data.link;
          this.listaTickets();
        }
      } catch (error) {
        this.$alertify.error(error.response.data.message);
      } finally {
        this.$store.commit('global/loaded');
      }
    },
    buttonLink(link) {
      if (navigator.clipboard && (link != undefined || link != '')) {
        navigator.clipboard.writeText(link).then(() => {
          this.$alertify.success('Link copiado com sucesso !!');
        });
      } else {
        this.$alertify.success('Link não gerado');
      }
    },
    async buttonNovo(registro) {
      this.$store.commit('global/loading');
      try {
        if (registro > 0) {
          const response = await api.put(`/api/rma/cliente/gerar/${registro}`);
          this.listaTickets();
        }
      } catch (error) {
        this.$alertify.error('teste');
      } finally {
        this.$store.commit('global/loaded');
      }
    },
    retornaTextoSituacao(situacao) {
      switch (situacao) {
        case 'V':
          return 'Visualizado';
        case 'S':
          return 'Confirmado';
        default:
          return 'Pendente';
      }
    },
    abre() {
      this.$store.commit('global/openModal');
    },
    retornaCorSituacao(situacao) {
      switch (situacao) {
        case 'V':
          return 'orange';
        case 'S':
          return 'green';
        default:
          return 'black';
      }
    },
    async listaTickets() {
      this.$store.commit('global/loading');
      try {
        const response = await api.get('/api/rma/cliente/gerados');
        if (response.data.url) {
          const json = await axios.get(response.data.url);
          this.dataItems = json.data.map((item) => {
            item.situacao = [
              {
                text: this.retornaTextoSituacao(item.confirmado),
                class: `ui label ${this.retornaCorSituacao(item.confirmado)} small`,
                style: 'text-align:center;',
                click: () => '',
              },
            ];
            item.dataexpiracao = item.dataexpiracao != '0000-00-00' ? item.dataexpiracao : '';
            item.textoVencido = item.vencido ? 'Sim' : 'Não';
            return item;
          });
        }
      } catch (error) {
        this.$alertify.error(error.response.data.message);
      } finally {
        this.$store.commit('global/loaded');
      }
    },
    formatarData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss">
  .box-json {
    .json {
      background-color: #282a36;
      color: #fff;
      white-space: break-spaces;
    }
  }
</style>
